import type { JwtPayload } from 'jwt-decode';

import type { Auth0Address } from './address';

export type Auth0Metadata = {
  first_name: string;
  last_name: string;
  role: UserRole;
  organization_invite_code?: string;
  phone_number?: string;
  address?: Auth0Address;
};

export type Auth0UpdateMetadata = {
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  address?: Auth0Address | null;
};

export type UserAppMetadata = {
  role: UserRole;
};

export type Session = {
  id?: string;
  provider?: string;
  idToken?: string;
  refreshToken?: string;
};

/** Session with guaranteed idToken. Does not imply the token is fresh or refreshable. */
export type AuthenticatedSession = Session & { idToken: string };

export type JwtIdToken = JwtPayload & {
  picture: string;
  email: string;
  email_verified: boolean;
  nickname: string;
  name: string;
  updated_at: string;
  auth_time: number;
  sid: string;
  given_name: string;
  family_name: string;
  user_metadata: Auth0Metadata;
  locale: string;
};

export type FormattedProfile = {
  email: string;
  picture: string;
};

// role assignment input map (auth0 > graphql)
export enum ROLE_MAP {
  supplier = 'SupplierRole',
  marketplace_user = 'MarketplaceUserRole',
  system_administrator = 'SystemAdministratorRole',
  conduit_employee = 'ConduitEmployeeRole',
  clinician = 'ClinicianRole',
}

export type UserRole = keyof typeof ROLE_MAP;
export const MARKETPLACE_USER_ROLE = 'marketplace_user' satisfies UserRole;
export const SUPPLIER_ROLE = 'supplier' satisfies UserRole;
export const SYSTEM_ADMINISTRATOR_ROLE = 'system_administrator' satisfies UserRole;
export const CONDUIT_EMPLOYEE_ROLE = 'conduit_employee' satisfies UserRole;
export const CLINICIAN_ROLE = 'clinician' satisfies UserRole;
